import React, { Component } from "react";
import Calendar from "../../../components/NewCalendar";
import Buttons from "../../../components/UI/Buttons";
import VisitsService from "../../../services/VisitsService";
import LookupService from "../../../services/LookupService";
import CompanyService from "../../../services/CompanyService";
import OrganizationService from "../../../services/OrganizationService";
import { convertUnderScoreStrings, isSet } from "../../../utils/commonUtils";
import { VISIT_CATEGORY, VISIT_STATUS } from "../../../utils/constant";
import WithRoutify from "../../../hoc/WithRoutify";
import withReduxState from "../../../hoc/wReduxState";
import CalendarWidget from "./CalendarWidget";
import Acl from "../../../hoc/Acl";
import PERMISSIONS from "../../../utils/AclPermissions";
import { fetchCurrentDate } from "../../../utils/DateUtils";
import DropDownService from "../../../services/DropDownService";
import GlobalSearch from "../../../components/Layouts/NewAppLayout/GlobalSearch/GlobalSearch";
import NewPatientCalendar from "./EmployerAdminCalender";
import moment from "moment";

class NewPatientAppointments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      calendarViewType: "WEEK",
      calendarParam: { from_date: "", to_date: "" },
      currentDay: undefined,
      filters: {},
      isCalendarWidgetDate: null,
      isModelOpen: false,
      isAddPatientModelOpen: false,
      calendarRecords: [],
      visitCategoryOptions: [],
      is_scheduled_visit: "ALL",
      clinic_id: "",
      companiesOptions: [],
      visitStatusOption: [],
      organizationList: [],
      visitsAutoFillData: {},
      visitCategoryOptions: [],
      autoEmployeeFillData: {},
      isVisitDetailViewOpen: false,
      visitId: null,
      snapClinicConsentForm: null,
      snapEmployeeDetails: null,
      snapVisitConsentForm: null,
      scanBarcodeModalOpen: false,
      scheduledType: [
        { label: "All", isActive: true, name: "ALL" },
        { label: "Scheduled", isActive: false, name: "true" },
        { label: "Walk In", isActive: false, name: "false" },
      ],
      clinicOptions: [],
      blockedDates: [],
      blockedDays: [],
      availabilitySlots: [],
      selectedVisitDate: null, // Store selected date from calendar widget
    };
  }

  componentDidMount = () => {
    const { calendarParam } = this.state;
    
    // Set default current date
    const today = new Date();
    const todayStr = moment(today).format('MM/DD/YYYY');
    this.setState({ 
      currentDay: today,
      selectedVisitDate: todayStr 
    });
    
    this.fetchAppointmentHistory(true);

    this.fetchVisitCategory();
    this.fetchCompaniesList();
    // if(isSet(this.props.profile) && !isSet(this.props.profile.role[0] === 'company_employee') ){

    // }
    this.fetchOrganization();
    this.fetchVisitStatus();
    this.fetchClinicOptions();
  };
  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.globalFilter.Appointments !==
      this.props?.globalFilter?.Appointments
    ) {
      this.fetchAppointmentHistory();
    }
  }
  fetchVisitList = async (visitId = this.props.params.visitId) => {
    const { Loader } = this.props;
    Loader(true);
    try {
      const data = await VisitsService.getVisits(visitId);
      this.setState({
        visitDetails: { ...data[0], ...data },
        employeeId: data[0].employee_id,
      });
      Loader(false);
    } catch (error) {
      Loader(false);
      console.error("Error fetching employee details:", error);
    }
  };
  fetchVisitStatus = async () => {
    try {
      const data = await LookupService.getLookupByKey(VISIT_STATUS);
      let visitStatusArr = [{ label: "-Visit Status-", value: "" }];
      data.forEach((item) => {
        visitStatusArr.push({
          label: item.value,
          value: item.value,
        });
      });
      this.setState({ visitStatusOption: visitStatusArr });
    } catch (e) {}
  };
  fetchOrganization = async () => {
    if (this.props.profile.is_multiple_organization === true) {
      let org = await OrganizationService.getOrganization();
      let orgOpt = [{ label: "-Select Organization-", value: "" }];
      isSet(org.data.data, []).forEach((itm) => {
        orgOpt.push({
          label: convertUnderScoreStrings(itm.name),
          value: itm.organization_uuid,
        });
      });
      this.setState({ organizationOption: orgOpt });
    }
  };
  fetchClinicOptions = async (val = null) => {
    try {
      const response = await DropDownService.getClinicList(val);
      console.log("fetchClinicOptions", response);

      // ✅ start with default option
      const clinicOptions = [{ label: "-Select Clinic-", value: "" }];

      // ✅ check if response is a valid array
      if (Array.isArray(response)) {
        response.forEach((clinic) => {
          clinicOptions.push({
            label: clinic.name,
            value: clinic.clinic_id,
          });
        });
      } 
      
      if (clinicOptions.length === 2) {
      const singleClinicId = clinicOptions[1].value;
      this.setState(
        {
          clinicOptions,
          clinic_id: singleClinicId,
        },
     
          this.handleClinicChange(singleClinicId)
      
      );
    }
      else {
        // response is not an array (maybe error object)
        console.error("Unexpected response:", response);
      }

      this.setState({ clinicOptions });
    } catch (error) {
      console.error("Failed to fetch clinic options:", error);
      // You could also set an error state here
      this.setState({
        clinicOptions: [{ label: "Error fetching clinics", value: "" }],
      });
    }
  };
  fetchAppointmentHistory = async (isLoader = false) => {
    const { calendarParam, is_scheduled_visit, clinic_id } = this.state;
    const globalFilter = this.props?.globalFilter?.Appointments || {};
    const { Loader } = this.props;
    const queryString = {
      ...globalFilter,
      visit_from: calendarParam.from_date,
      visit_to: calendarParam.to_date,
      is_scheduled_visit: is_scheduled_visit,
      clinic_id: clinic_id,
    };
    // if (isSet(this.props.profile) && isSet(this.props.profile.role[0] === 'company_employee')) {
    //   queryString.employee_id = this.props.profile.employee_id;
    // }
    if (isLoader === true) {
      Loader(true);
    }
    try {
      const data = await VisitsService.getVisitsHistory(queryString);
      Loader(false);
      this.setState({ calendarRecords: data });
      // console.log('AppoitmentHistory',data);
    } catch (e) {
      Loader(false);
    }
  };
  fetchClinicAvailability = async (clinic_id) => {
    try {
      const empDetails = await VisitsService.clinicAvailability(clinic_id);
      // console.log("Employee details:", empDetails);

      // 1. Exact holiday dates where is_active != 0
      const blockedDates = (empDetails?.data?.holidays || [])
        .filter((h) => h.is_active !== 0)
        .map((h) => ({
          date: h.date, // "MM/DD/YYYY"
          reason: h.reason || "Holiday",
        }));

      // 2. Weekdays where is_repeatable = 0
      const blockedDays = (empDetails?.data?.availability || [])
        .filter((day) => day.is_repeatable === 0)
        .map((day) => day.day.toUpperCase()); // ["SUN", "WED"]

      // 3. Slots per weekday (for partial blocking)
      //    Structure: { "MON": [ { from_time, to_time }, ... ], ... }
      const availabilitySlots = {};
      (empDetails?.data?.availability || []).forEach((day) => {
        availabilitySlots[day.day.toUpperCase()] = day.slots || [];
      });

      this.setState({
        clinicAvailability: empDetails,
        blockedDates, // exact date-based full-day block
        blockedDays, // full-weekday block
        availabilitySlots, // per-day allowed time slots
      });
    } catch (err) {
      console.error("Error fetching employee details:", err);
    }
  };

  calendarActionHandler = async (
    calendarViewType = "WEEK",
    calendarParam = {},
    currentDay = ""
  ) => {
    if (currentDay === "") {
      currentDay = fetchCurrentDate();
    }

    // console.log('calendarViewType',calendarViewType);
    this.setState(
      {
        calendarParam: calendarParam,
        currentDay: currentDay,
        calendarViewType: calendarViewType,
      },
      () => this.fetchAppointmentHistory()
    );
    // await this.changeGridViewHandler('CALENDAR',{},true,calendarViewType,calendarParam,currentDay)
  };
  setActiveScheduled = (val) => {
    let { scheduledType, filters } = this.state;
    const { label, name, isActive } = val;
    let updatedTab = scheduledType.map((item) => {
      if (item.label == label) {
        item.isActive = true;
      } else {
        item.isActive = false;
      }
      return item;
    });
    this.setState(
      (prevState) => ({
        scheduledType: updatedTab,
        is_scheduled_visit: name,
      }),
      () => this.fetchAppointmentHistory()
    );
  };
  addVisitToogleHandler = (autoFillData = {}) => {
    // console.log('autoFillData',autoFillData);
    this.setState({
      isModelOpen: !this.state.isModelOpen,
      visitsAutoFillData: autoFillData,
    });
  };
  addNewEmployeeToogleHandler = (
    bool = false,
    nextStep = null,
    autoFillData
  ) => {
    console.log("nextStep", nextStep, bool, nextStep, autoFillData);
    if (nextStep === "ADD_VISIT") {
      this.setState(
        {
          visitsAutoFillData: autoFillData,
          isAddPatientModelOpen: bool,
        },
        () => this.addVisitToogleHandler(autoFillData)
      );
    } else {
      this.setState({
        visitsAutoFillData: autoFillData,
        isAddPatientModelOpen: bool,
        isModelOpen: false,
        autoEmployeeFillData: {},
      });
    }
  };
  fetchVisitCategory = async () => {
    try {
      const data = await LookupService.getLookupByKey(VISIT_CATEGORY);
      let visitCategoryArr = [{ label: "-Visit Category-", value: "" }];
      data.forEach((item) => {
        visitCategoryArr.push({
          label: item.value,
          value: item.value,
        });
      });
      this.setState({ visitCategoryOptions: visitCategoryArr }, () => {});
    } catch (e) {
      // this.fetchVisitsList();
    }
  };
  fetchCompaniesList = async (query = "") => {
    // this.props.Loader(true);
    CompanyService.getCompanies(query)
      .then((res) => {
        let companiesOptions = [{ label: "-Select Company-", value: "" }];
        res.data.data.forEach((company) => {
          companiesOptions.push({
            label: company.name,
            value: company.company_uuid,
          });
        });
        this.setState({
          companiesOptions: companiesOptions,
        });
      })
      .catch((err) => {
        console.log("err===>", err);
      })
      .finally(() => {
        this.props.Loader(false);
      });
  };
  visitDetailViewModal = (
    visitId = null,
    clinicConsentForm = null,
    snapEmployeeDetails = null,
    snapVisitConsentForm = null,
    fetch = false
  ) => {
    if (fetch) {
      this.fetchAppointmentHistory();
    }
    this.setState((oldState) => ({
      isVisitDetailViewOpen: !oldState.isVisitDetailViewOpen,
      visitId: visitId,
      snapClinicConsentForm: clinicConsentForm,
      snapEmployeeDetails: snapEmployeeDetails,
      snapVisitConsentForm: snapVisitConsentForm,
    }));
  };
  setCurrentDate = (val, calendarViewType) => {
    this.setState({
      currentDay: val,
      calendarViewType: calendarViewType,
      isCalendarWidgetDate: val,
    });
  };
  
  handleDateClickInCalendar = (formattedDate, dateObj) => {
    // This is called when a date is clicked in CalendarWidget
    // formattedDate is already in MM/DD/YYYY format from CalendarWidget
    
    // Update the current day state
    this.setCurrentDate(dateObj, 'DAY');
    
    // Store the selected visit date for EmployerAdminCalender
    this.setState({ selectedVisitDate: formattedDate });
    
    // If we have availability slots, filter them based on the selected date
    if (this.state.availabilitySlots && Object.keys(this.state.availabilitySlots).length > 0) {
      const dayName = dateObj.toLocaleDateString("en-US", { weekday: "long" });
      const dayAbbr = dayName.toUpperCase().substring(0, 3);
      const daySlots = this.state.availabilitySlots[dayAbbr] || [];
      
      // You can add additional filtering logic here if needed
      console.log('Selected date:', formattedDate, 'Available slots:', daySlots);
    }
  };
  scanBarcodeHandler = (obj = {}, isAddEmployee = false) => {
    this.setState({
      scanBarcodeModalOpen: !this.state.scanBarcodeModalOpen,
      autoEmployeeFillData: obj,
      isAddPatientModelOpen: isAddEmployee,
      isModelOpen: false,
    });
  };
  handleClinicChange = (clinic_id) => {
    this.setState({ clinic_id }, () => {
      this.fetchAppointmentHistory();
      this.fetchClinicAvailability(clinic_id);
    });
  };

  render() {
    const {
      calendarParam,
      filters,
      isAddPatientModelOpen,
      autoEmployeeFillData,
      visitsAutoFillData,
      visitCategoryOptions,
      isModelOpen,
      scheduledType,
      setActiveScheduled,
      clinic_id,
    } = this.state;
    const {
      isVisitDetailViewOpen,
      visitStatusOption,
      visitId,
      snapClinicConsentForm,
      snapEmployeeDetails,
      snapVisitConsentForm,
      visitDetails,
    } = this.state;
    // Add a GlobalSearchFilter paths
    const globalSearchFilter = [
      "/visits",
      "/appointments",
      "/white-board",
      "/labs",
      "/result/vaccine",
      "/result/physical-drug-screens",
      "/employee",
    ];
    const { profile, location } = this.props;
    const { pathname } = location;
    return (
      <>
        {/*this a GlobalSearch field */}
       {/* {profile &&
          profile.is_multiple_organization === false &&
          profile.employee_login === true &&
          globalSearchFilter.some((path) => pathname.startsWith(path)) && (
            <GlobalSearch
              activeMenu={"Appointments"}
              pathname={pathname}
            />
        )} */}

        {/* This is your main content card, now BELOW the GlobalSearch */}
        <div className="sh_cardBox">
           <div className="sh_cardHeader pb-0">
              <div class="d-flex flex-column">
                <div class="d-flex">
                  <h2 class="h2-strong">Appointments</h2>
                </div>
                
              </div>
           </div>
          <div className="sh_cardBody p-0">
            <div className="row h-100 ">
              <div
                className="col-12 col-lg-3 pt-2"
                style={{
                //   height: "calc(88vh - 95px)",
                  overflowY: "auto",
                  scrollbarWidth: "thin",
                }}
              >
                <CalendarWidget
                  currentDay={this.state.currentDay}
                  calendarViewType={this.state.calendarViewType}
                  setCurrentDate={this.setCurrentDate}
                  disabledDates={this.state.blockedDates?.map(b => b.date) || []}
                  disabledDays={this.state.blockedDays || []}
                  onDateClick={this.handleDateClickInCalendar}
                />
            </div>
              <div
                className="col-lg-9 col-12"
                style={{ height: "100calc(88vh - 95px)vh" }}
              >
                <div className="sh_cardBox sh_cardbglight h-100 sh-calendarht border-0 p-2">
                    
                  <NewPatientCalendar selectedVisitDate={this.state.selectedVisitDate} />
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default WithRoutify(withReduxState(NewPatientAppointments));
